/* External dependencies */
import { AnyAction } from 'redux';

/* Local dependencies */
import { UpdateDeviceInput, Device } from '../../types';

export enum UpdateDeviceActionTypes {
  UPDATE_DEVICE_REQUEST = 'UPDATE_DEVICE_REQUEST',
  UPDATE_DEVICE_SUCCESS = 'UPDATE_DEVICE_SUCCESS',
  UPDATE_DEVICE_FAILURE = 'UPDATE_DEVICE_FAILURE',
}

export interface UpdateDeviceAction extends AnyAction {
  type: UpdateDeviceActionTypes.UPDATE_DEVICE_REQUEST;
  payload: UpdateDeviceInput;
}

export interface UpdateDeviceSuccessAction extends AnyAction {
  type: UpdateDeviceActionTypes.UPDATE_DEVICE_SUCCESS;
  payload: Device;
}

export interface UpdateDeviceFailureAction extends AnyAction {
  type: UpdateDeviceActionTypes.UPDATE_DEVICE_FAILURE;
  payload: string;
}

export const updateDeviceAction = (input: UpdateDeviceInput): UpdateDeviceAction => ({
  type: UpdateDeviceActionTypes.UPDATE_DEVICE_REQUEST,
  payload: input,
});

export const updateDeviceSuccess = (device: Device): UpdateDeviceSuccessAction => ({
  type: UpdateDeviceActionTypes.UPDATE_DEVICE_SUCCESS,
  payload: device,
});

export const updateDeviceFailure = (error: string): UpdateDeviceFailureAction => ({
  type: UpdateDeviceActionTypes.UPDATE_DEVICE_FAILURE,
  payload: error,
}); 